module.exports = __webpack_public_path__ + "static/maricopa-71711c40da5ba964f68f02e5be548356.png";